<script>
    import { currentUser } from "./stores/user.js";
    import { Router, Link, Route } from "svelte-routing";
    import Home from "./pages/Home.svelte";
    import Login from "./pages/Login.svelte";
    import Courses from "./pages/courses/Courses.svelte";
    import Categories from "./pages/Categories.svelte";
    import Articles from "./pages/articles/Articles.svelte";
    import AboutPages from "./pages/about/AboutPages.svelte";
    import Assets from "./pages/Assets.svelte";
    import Header from "./components/Header.svelte";
    import Loading from "./components/Loading.svelte";
    import Notifications from "./components/Notifications.svelte";
    import { _ } from "svelte-i18n";
    import {
        HOME_DOC,
        CATEGORY_DOC,
        COURSE_DOC,
        ARTICLE_DOC,
        ABOUT_DOC,
    } from "./models";
    import FirestoreDoc from "./components/firestore/FirestoreDoc.svelte";
    import FirestoreEditor from "./components/firestore/FirestoreEditor.svelte";
    import { ABOUT_MAIN_DOC } from "./models/about.js";

    export let url = "";
</script>

<svelte:head>
    <title>{$_("Title")}</title>
</svelte:head>

<Router {url}>
    <Loading />
    <Notifications />
    <Header />
    <div class="flex-grow">
        {#if $currentUser}
            {#if $currentUser.active}
                <Route path="/" component={Home} />
                <Route path="/categories" component={Categories} />
                <Route path="/categories/:uid" let:params>
                    <main class="p-4">
                        <FirestoreDoc
                            path="/categories"
                            uid={params.uid}
                            let:document>
                            <FirestoreEditor
                                path="/categories"
                                uid={params.uid}
                                doc={document}
                                deletable={true}
                                form={CATEGORY_DOC} />
                        </FirestoreDoc>
                    </main>
                </Route>
                <Route path="/courses" component={Courses} />
                <Route path="/courses/:uid" let:params>
                    <main class="p-4">
                        <FirestoreDoc
                            path="/courses"
                            uid={params.uid}
                            let:document>
                            <FirestoreEditor
                                path="/courses"
                                uid={params.uid}
                                doc={document}
                                deletable={true}
                                form={COURSE_DOC} />
                        </FirestoreDoc>
                    </main>
                </Route>
                <Route path="/assets" component={Assets} />
                <Route path="/blog" component={Articles} />
                <Route path="/blog/:uid" let:params>
                    <main class="p-4">
                        <FirestoreDoc
                            path="/articles"
                            uid={params.uid}
                            let:document>
                            <FirestoreEditor
                                path="/articles"
                                uid={params.uid}
                                doc={document}
                                deletable={true}
                                form={ARTICLE_DOC} />
                        </FirestoreDoc>
                    </main>
                </Route>
                <Route path="/about" component={AboutPages} />
                <Route path="/about_page">
                    <main class="p-4">
                        <FirestoreDoc path="/pages" uid="about" let:document>
                            <FirestoreEditor
                                path="/pages"
                                uid="about"
                                doc={document}
                                deletable={false}
                                form={ABOUT_MAIN_DOC} />
                        </FirestoreDoc>
                    </main>
                </Route>
                <Route path="/about/:uid" let:params>
                    <main class="p-4">
                        <FirestoreDoc
                            path="/about"
                            uid={params.uid}
                            let:document>
                            <FirestoreEditor
                                path="/about"
                                uid={params.uid}
                                doc={document}
                                deletable={true}
                                form={ABOUT_DOC} />
                        </FirestoreDoc>
                    </main>
                </Route>
                <Route path="/homepage">
                    <main class="p-4">
                        <FirestoreDoc path="/pages" uid="home" let:document>
                            <FirestoreEditor
                                path="/pages"
                                uid="home"
                                doc={document}
                                deletable={false}
                                form={HOME_DOC} />
                        </FirestoreDoc>
                    </main>
                </Route>
            {:else}
                <main
                    class="px-4 pt-16 flex flex-col justify-center items-center">
                    <h1>{$_("NotActive")}</h1>
                    <p class="mt-4">{$_("NotActiveContact")}</p>
                </main>
            {/if}
        {:else}
            <Route path="/" component={Login} />
        {/if}
    </div>
</Router>
